import React from "react";
import PropTypes from "prop-types";
import { IoIosSearch } from "react-icons/io";

import "./Search.scss";

export default function Search(props) {
  return (
    <div className="searchDiv">
      <IoIosSearch size={24} />
      <input
        placeholder={props.placeholder}
        // value={props.value}
        onChange={props.onChange}
      />
    </div>
  );
}

Search.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};
